{
  "common": {
    "survey": "Kysely",
    "cancel": "Peruuta",
    "submit": "Lähetä",
    "previewAndSave": "Esikatsele ja tallenna",
    "save": "Tallenna",
    "saveError": "Tallennuksessa tapahtui virhe",
    "add": "Lisää",
    "remove": "Poista",
    "edit": "Muokkaa",
    "clear": "Tyhjennä",
    "preview": "Esikatsele",
    "search": "Haku",
    "showAll": "Näytä kaikki",
    "showLess": "Näytä vähemmän",
    "continue": "Jatka",
    "next": "Seuraava",
    "previous": "Edellinen",
    "verifyFormData": "Tarkista tiedot",
    "toFrontPage": "Palaa etusivulle",
    "name": "Nimi",
    "firstName": "Etunimi",
    "lastName": "Sukunimi",
    "username": "Käyttäjänimi",
    "studentNumber": "Opiskelijanumero",
    "degreeProgram": "Kohderyhmä",
    "email": "Sähköpostiosoite",
    "value": "Arvo",
    "type": "Tyyppi",
    "isRequired": "Kenttä on pakollinen.",
    "required": "Pakollinen",
    "yes": "Kyllä",
    "no": "Ei",
    "and": "ja",
    "open": "Avoinna",
    "closed": "Suljettu",
    "closing": "Sulkeutuu",
    "pending": "Odottava",
    "back": "Takaisin",
    "page": "Sivu",
    "close": "Sulje",
    "modifiedAt": "Muokattu",
    "createdAt": "Luotu",
    "description": "Kuvaus",
    "dropdown": {
      "prompt": "Valitse vaihtoehto"
    },
    "status": "Tila",
    "version": "Versio",
    "select": "Valitse",
    "question": "Kysymys",
    "periods": {
      "spring": "Kevät",
      "fall": "Syksy"
    },
    "dateTime": "Päivämäärä ja kellonaika",
    "new": "Uusi",
    "schema": "Kyselypohja"
  },
  "surveyType": {
    "DEGREE_PROGRAM_SURVEY": "HowULearn-kysely",
    "COURSE_SURVEY": "HowUStudy-kysely",
    "HUP": "PhD-kysely",
    "HUT": "HowUTeach-kysely",
    "NOT_DEFINED": "Ei määritelty"
  },
  "errorPage": {
    "errorHappened": "Sovelluksessa tapahtui virhe",
    "accessDeniedError": "Sinulla ei ole käyttöoikeutta pyytämääsi sivuun tai toimintoon.",
    "unknownError": "Tunnistamaton virhe",
    "notFound": "Hakemaasi sivua ei löytynyt"
  },
  "confirmButton": {
    "confirmCancel": "Haluatko varmasti perua tekemäsi muutokset?"
  },
  "languageSelector": {
    "fi": "Suomi",
    "en": "English",
    "sv": "Svenska"
  },
  "inLanguage": {
    "fi": "Suomeksi",
    "en": "Englanniksi",
    "sv": "Ruotsiksi"
  },
  "login": {
    "chooseUser": "Valitse käyttäjä",
    "chooseOrganization": "Valitse organisaatio"
  },
  "organizations": {
    "UH": "Helsingin yliopisto",
    "TEST": "Testiorganisaatio",
    "AALTO": "Aalto-yliopisto",
    "HAMK": "Hämeen ammattikorkeakoulu",
    "METROPOLIA": "Metropolia Ammattikorkeakoulu",
    "FUNIDATA": "Funidata Testu Yliopisto",
    "ABO": "Åbo Akademi"
  },
  "userMenu": {
    "logOut": "Kirjaudu ulos",
    "openLogoutMenu": "Avaa kieli- ja uloskirjautumisvalikko",
    "closeLogoutMenu": "Sulje kieli- ja uloskirjautumisvalikko",
    "changeLanguage": "Vaihda kieli"
  },
  "surveyUserList": {
    "responseDate": "Vastauspäivä"
  },
  "frontPage": {
    "intro": "UniHow on tutkimuspohjainen oppimisen ja opetuksen tukijärjestelmä.",
    "yourSurveys": "Sinulle kohdistetut kyselyt",
    "youHaveNoSurveys": "Sinulle ei ole kohdistettuja kyselyitä",
    "wantToStartASurvey": "Haluatko käynnistää uuden kyselyn?",
    "startSurveyInfo": "Siirry tarkastelemaan ja käynnistämään uusi kysely",
    "startSurvey": "Käynnistä uusi kysely",
    "description": "<h3>UniHow palvelee seuraavasti</h3><p>UniHow tuottaa vastausten perusteella vastapalautteen, joka rohkaisee vastaajaa esimerkiksi omien opiskelu- tai opetustapojen tarkasteluun.</p><p>UniHow tuottaa helposti luettavia ja ymmärrettäviä raportteja kyselyyn vastanneista ryhmistä. Raportteja ja aineistoja voidaan hyödyntää esimerkiksi opetuksen kehittämisessä.</p><p>Järjestelmän kautta kerätty data voidaan vaivattomasti siirtää tilasto-ohjelmiin analysoitavaksi ja käyttää tutkimusaineistona.</p>",
    "whatIsUniHow": "Mikä on UniHow?",
    "surveyBoxList": {
      "surveyTypes": {
        "DEGREE_PROGRAM_SURVEY": "HowULearn-kyselyt",
        "COURSE_SURVEY": "HowUStudy-kyselyt",
        "HUP": "PhD-kyselyt",
        "HUT": "HowUTeach-kyselyt"
      },
      "answerSurvey": "Vastaa kyselyyn",
      "viewFeedback": "Tutustu palautteeseen",
      "showMore": "Näytä lisää",
      "responseMessages": {
        "answered": "Olet vastannut kyselyyn",
        "notAnswered": "Et vastannut kyselyyn",
        "waiting": "Kysely odottaa vastaamistasi"
      },
      "endingMessages": {
        "ended": "Kysely päättyi",
        "notEnded": "Kysely päättyy"
      },
      "feedbackMessages": {
        "notEnoughResponses": "Palautetta ei voida näyttää, koska kyselyyn ei saatu riittävästi vastauksia.",
        "notAnswered": "Palautetta ei voida näyttää, koska et vastannut kyselyyn.",
        "shownAfterClosed": "Palaute näytetään, jos vastauksia on riittävästi, kun kysely on sulkeutunut.",
        "feedbackWaiting": "Palaute odottaa tutustumistasi",
        "feedbackViewed": "Olet tutustunut palautteeseen",
        "hourglassAltText": "Tiimalasi",
        "closeAltText": "Rasti",
        "checkAltText": "Tarkistusmerkki"
      }
    },
    "instructions": {
      "title": "Ohjeet kyselyyn vastaajalle",
      "step1": {
        "title": "Vastaa kyselyyn",
        "description": "Avaa avoinna oleva kysely ja vastaa kysymyksiin ja väittämiin omien opiskelukokemustesi pohjalta."
      },
      "step2": {
        "title": "Odota kyselyn sulkeutumista",
        "description": "UniHow laskee tulokset ja luo henkilökohtaisen palautteesi, kun kaikki vastaukset on kerätty ja kysely on sulkeutunut. Vastauksesi suhteutetaan muihin kyselyyn osallistuneiden vastauksiin."
      },
      "step3": {
        "title": "Tutustu palautteeseen",
        "description": "Saat sähköpostiisi viestin, josta löydät linkin omaan palautteeseesi. Palaute sisältää asiantuntijoiden vinkkejä sekä tietoa omasta tavastasi työskennellä verrattuna muihin samaan kyselyyn osallistuneisiin."
      }
    }
  },
  "links": {
    "activityLog": "Aktiviteettiloki",
    "myHowULearnSurveys": "Omat HowULearn-kyselyni",
    "myHowUStudySurveys": "Omat HowUStudy-kyselyni",
    "surveySchemas": "Kyselypohjat",
    "permissions": "Käyttöoikeudet",
    "surveyReports": "Kyselyjen koontiraportit",
    "serviceReports": "Palvelun käyttöraportit",
    "degreeProgramSurveys": "HowULearn-kyselyt",
    "courseSurveys": "HowUStudy-kyselyt",
    "teacherSurveys": "HowUTeach-kyselyt",
    "studentInfo": "Tietoa opiskelijoista",
    "extraSurveyParts": "Lisäkysymykset"
  },
  "linkGroupTitles": {
    "ownCourses": "Omat toteutukset",
    "howUTeach": "HowUTeach",
    "settings": "Asetukset",
    "reports": "Raportit",
    "studentSurveys": "Opiskelijan kyselyt",
    "surveys": "Kyselyt"
  },
  "surveyLoadingError": "Virhe kyselyn haussa",
  "surveyProgress": "Eteneminen kyselyssä",
  "requiredQuestionInfo": "*-merkityt kysymykset ovat pakollisia",
  "responseMessage": {
    "responseSuccess": "Kiitos vastauksestasi.",
    "responded": "Olet jo vastannut tähän kyselyyn"
  },
  "survey": {
    "part": "Osa",
    "researchConsent": "Vastauksiani saa käyttää tutkimustarkoituksiin",
    "researchConsentTitle": "Tutkimusluvan antaminen",
    "responseSentTitle": "Kysely lähetetty",
    "responseSent": "Kyselyn vastaukset lähetetty",
    "close": "Sulje kysely",
    "participants": "Osallistujat",
    "scheduling": "Ajoitukset",
    "remind": "Muistuta",
    "responseSuccess": "Kiitos osallistumisesta! Järjestelmä antaa sinulla palautetta vastaustesi perusteella. Palautteessa saat ohjeita opiskeluun vastaustesi perusteella, sekä näet omat vastauksesi suhteessa muiden opiskelijoiden vastauksiin. Saat sähköpostiisi viestin, kun palautteesi on luettavissa UniHow-palvelussa.",
    "reopen": "Avaa kysely uudelleen",
    "export": {
      "title": "Lataa tiedot",
      "excel": "Lataa tiedot (Excel)",
      "sensitiveExcel": "Lataa tiedot tutkimuskäyttöön",
      "description": "Olet lataamassa kyselyn tietoja tutkimuskäyttöön.",
      "enterReason": "Kuvaile ladattavien tietojen käyttötarkoitusta tarkemmin (esim. tutkimusongelma ja tutkimuskysymykset).",
      "checkbox": "Vakuutan, että käytän lataamiani tietoja vain yllä kuvaamaani tutkimuskäyttöön."
    },
    "sensitiveInfoNotification": "Ethän kirjoita vastauksiisi terveystietoja tai muita arkaluontoisia tietoja."
  },
  "surveyParticipantsEditor": {
    "NO_EMAIL": "Sähköpostiosoite puuttuu",
    "DUPLICATE_EMAIL": "Toinen vastaaja käyttää jo samaa sähköpostiosoitetta",
    "NOT_FOUND": "Opiskelijaa ei löytynyt.",
    "INVALID_EMAIL": "Sähköpostiosoite on viallinen",
    "CHANGING_EMAIL": "Tälle opiskelijanumerolle on jo tallennettu eri sähköpostiosoite. Vahvista kumpaa käytetään.",
    "ALREADY_IN_SURVEY": "On jo kyselyn vastaanottajissa.",
    "surveyHasExistingParticipants": "aiemmin lisättyä osallistujaa.",
    "surveyHasExistingParticipant": "aiemmin lisätty osallistuja.",
    "addParticipantDescription": "Voit lisätä tai kopioida listan opiskelijoita erottamalla opiskelijanumerot pilkulla, välilyönnillä tai rivinvaihdoilla.",
    "addParticipantPlaceholder": "Toteutuksen tunniste tai opiskelijanumero",
    "courseRealisationIdHelp": "Toteutuksen tunnisteen löydät opintotietojärjestelmästä, tarkista oman korkeakoulusi ohjeet toteutuksen osallistujien lisäämisestä.",
    "enterEmail": "Syötä sähköpostiosoite",
    "selectEmail": "Valitse sähköpostiosoite",
    "studentRegistry": "Opintotietojärjestelmä",
    "loading": "Haetaan tietoja...",
    "noSelectedCourses": "Ei valittuja toteutuksia",
    "participantsSearchTitle": "Lisää opiskelijoita opiskelijanumerolla tai toteutuksen tunnisteella.",
    "recipients": "Vastaanottajat",
    "studentsAdded": "opiskelijaa lisätty.",
    "studentAdded": "opiskelija lisätty.",
    "studentsRejected": "opiskelijanumeroa hylätty.",
    "studentRejected": "opiskelijanumero hylätty.",
    "studentsAlreadyAdded": "opiskelijaa on jo mukana kyselyssä.",
    "studentAlreadyAdded": "opiskelija on jo mukana kyselyssä.",
    "requiresActionPl": "opiskelijaa vaatii korjausta.",
    "requiresActionSg": "opiskelija vaatii korjausta.",
    "participantsAlreadyAdded": "annettua henkilöä oli jo vastaanottajissa.",
    "participantAlreadyAdded": "annettu henkilö on jo vastaanottajissa.",
    "missingCourseNames": "nimeämätöntä toteutusta lisätty opintotietojärjestelmästä.",
    "missingCourseName": "nimeämätön toteutus lisätty opintotietojärjestelmästä.",
    "totalParticipants": "Osallistujia yhteensä ${ totalParticipantCount }",
    "missingEmails": "Osallistujat, joilla ei ole voimassa olevaa sähköpostiosoitetta, eivät saa kutsua kyselyyn.",
    "missingEppns": "Osallistujat, joilta puuttui EPPN, jätettiin pois toteutuksesta.",
    "teacherParticipantsEditor": {
      "searchLabel": "Lisää osallistujia sähköpostiosoitteiden avulla.",
      "placeholder": "Osallistujan sähköposti",
      "description": "Osallistujia voi lisätä useamman kerralla erottamalla sähköpostiosoitteet pilkulla, välilyönnillä tai rivinvaihdolla.",
      "participantAdded": "osallistuja lisätty.",
      "participantsAdded": "osallistujaa lisätty.",
      "participantRejected": "sähköposti hylätty.",
      "participantsRejected": "sähköpöstia hylätty.",
      "recipients": "Sähköpostiosoitteiden kautta lisätyt osallistujat",
      "NOT_FOUND": "Henkilöä ei löytynyt."
    }
  },
  "addSurveyParticipants": {
    "title": "Muokkaa kyselyn osallistujia",
    "editParticipants": "Muokkaa osallistujia",
    "saved": "Osallistujat tallennettu"
  },
  "editSurvey": {
    "title": "Muokkaa kyselyä"
  },
  "startSurvey": {
    "schemaInfo": {
      "title": "Kyselypohjan tiedot",
      "version": "Kyselypohjan versio"
    },
    "courseSurvey": {
      "startDate": "Kyselyn alkamisajankohta",
      "endDate": "Kyselyn päättymisajankohta ja yhteenvedon aukeaminen",
      "startDateHelp": "Alkamisajankohdan asettaminen menneisyyteen käynnistää kyselyn välittömästi.",
      "endDateHelp": "Kyselyn yhteenveto on nähtävissä tänä ajankohtana."
    },
    "startTitle": "Kyselyn aloitus",
    "endTitle": "Kyselyn lopetus",
    "startSurvey": "Aloita kysely",
    "selectSchema": "Tyypin valinta",
    "content": "Sisältö",
    "noSelectedParticipants": "ei valittuja osallistujia",
    "basicInfo": "Perustiedot",
    "name": "Nimi",
    "nameDescription": {
      "degreeProgramSurvey": "Voit lisätä kyselyn nimeen tarkentavan osan, esimerkiksi \"Ryhmä 1\".",
      "defaultSurvey": "Anna kyselylle kuvaava nimi. Nimi näkyy osallistujalle tässä muodossa."
    },
    "recipients": "Opiskelijat",
    "courses": "Toteutukset",
    "introduction": "Aloitusteksti",
    "introductionDescription": "Voit halutessasi muokata osallistujalle näkyvää kyselyn aloitustekstiä.",
    "completion": "Lopetusteksti",
    "conclusionDescription": "Voit halutessasi muokata osallistujalle näkyvää kyselyn lopetustekstiä.",
    "messages": "Ajastus ja viestit",
    "selectDegreeProgram": "Valitse opiskelijaryhmä, jolle haluat kohdistaa kyselyn",
    "degreeProgramNotSelected": "-",
    "degreeProgramDescription": "Valitse alasvetovalikosta opiskelijaryhmä, jolle haluat kohdistaa kyselyn",
    "email": {
      "invitationTitle": "Kyselyn avautuminen ja kutsuviesti",
      "invitationTitleDescription": "Kutsuviesti lähtee osallistujan sähköpostiosoitteeseen kyselyn avautuessa. Kutsuviestiä voi muokata. Aseta oletusteksti –painike palauttaa alkuperäisen tekstin.",
      "endingTitle": "Kyselyn sulkeutuminen ja sulkeutumisviesti",
      "endingTitleDescription": "Kyselyn sulkeutumisviestillä osallistujaa tiedotetaan siitä, että hänen palautteensa on nyt luettavissa. Viestiä voi muokata. Aseta oletusteksti –painike palauttaa alkuperäisen tekstin.",
      "setDefaultTitle": "Aseta oletusotsikko",
      "emailTitle": "Viestin otsikko",
      "setDefaultContent": "Aseta oletusteksti",
      "emailContent": "Viestin sisältö",
      "invitationEmailContentHelp": "Kutsuviestin sisällön luomisen aputeksti",
      "endingEmailContentHelp": "Lopetusviestin sisällön luomisen aputeksti"
    },
    "researchConsent": {
      "title": "Tutkimuslupa",
      "consentNotNeeded": "Tutkimuslupaa ei tarvita",
      "description": "(Käytä tätä vain, jos olet keskustellut asiasta korkeakoulusi tutkimuksesta vastaavan tahon kanssa)"
    },
    "participantsAndScheduling": "Osallistujat",
    "scheduling": "Ajoitus",
    "startDate": "Kyselyn alkamisajankohta",
    "startDateHelp": "Kyselyn kutsuviestit lähetetään tänä ajankohtana. Alkamisajankohdan asettaminen menneisyyteen käynnistää kyselyn välittömästi.",
    "endDate": "Kyselyn päättymisajankohta ja palautteen aukeaminen",
    "endDateHelp": "Kyselyn palaute aukeaa tänä ajankohtana.",
    "submitSuccess": "Kysely luotu onnistuneesti",
    "submitSuccessLinkExplanation": "Suora linkki kyselyyn (huom. Linkki toimii vain kyselyyn kutsutuilla):",
    "viewQuestions": {
      "view": "Katso kyselyn kysymykset",
      "title": "Kyselyn kysymykset"
    },
    "surveyParts": {
      "title": "Osakyselyt",
      "introduction": "Kyselypohja sisältää alla luetellut osakyselyt."
    },
    "extraSurveyPart": {
      "title": "Lisäkysymykset",
      "introduction": "Voit valita kyselyn loppuun lisäkysymykset, jotka voivat olla määritelty esimerkiksi tietylle koulutusohjelmalle.",
      "add": "Valitse lisäkysymykset",
      "help": "Valitse kyselyyn lisättävät lisäkysymykset. Lisättyjen lisäkysymysten kysymykset ja väittämät näytetään vastaajille kyselyn lopussa varsinaisen kyselypohjan kysymysten ja väittämien jälkeen."
    },
    "reminder": {
      "addReminderSchedule": "Lisää muistutusviestin ajoitus"
    },
    "courseList": {
      "courseCode": "Opetuksen toteutuksen tunnus: ${ code }",
      "numberOfParticipants": "Toteutuksella yhteensä osallistujia: ${ amount }",
      "noSelectedCourses": "ei valittuja toteutuksia",
      "participantsInfo": "Toteutuksen osallistujalista voi muuttua siihen asti, kunnes ilmoittautumiset on vahvistettu."
    }
  },
  "surveyReminder": {
    "title": "Kyselyn muistutusviesti",
    "messageSent": "Kyselyn muistutusviesti lähetetty"
  },
  "viewSurveyResponse": {
    "title": "Vastaukset"
  },
  "surveySummary": {
    "title": "Palaute",
    "summaryHeading": "Yhteenveto",
    "radarChartExplanation": "Yhteenveto",
    "radarChartItemDescription": "${ name }: oma keskiarvo: ${ userAverage }. Ryhmän keskiarvo: ${ groupAverage }",
    "userAverage": "Oma keskiarvo",
    "groupAverage": "Ryhmän keskiarvo",
    "userTotal": "Oma arvo",
    "improvementSuggestions": "Vinkkejä kehittymiseen",
    "interpretation": "Palautteen tulkinta",
    "average": "Keskiarvo",
    "standardDeviation": "Keskihajonta",
    "value1Explanation": "1 - Kuvaa tilannettasi heikosti",
    "value5Explanation": "5 - Kuvaa tilannettasi vahvasti",
    "feedbackComputedAt": "Palaute laskettu",
    "ownResponse": "Palautteeseen liittyvät omat vastaukset",
    "responseDate": "Vastattu"
  },
  "richText": {
    "bold": "lihavointi",
    "italic": "kursivointi",
    "underline": "alleviivaus",
    "ul": "lista",
    "ol": "numeroitu lista"
  },
  "pageNotFound": "Sivua ei löydy",
  "connectionError": "Yhteysvirhe",
  "errorInResponseTo": "Virheilmoitus kutsulle",
  "header": {
    "siteTitle": "UniHow",
    "logo": {
      "label": "UniHow’n etusivu",
      "description": "UniHow-logo"
    },
    "navigation": {
      "surveys": "Kyselyt",
      "surveySchemas": "Kyselypohjat",
      "adminTools": "Pääkäyttäjän työkalut"
    },
    "openMenu": "Avaa navigaatio",
    "closeMenu": "Sulje navigaatio"
  },
  "footer": {
    "switchboard": "Puhelinvaihde",
    "dps": "Tietosuojailmoitus",
    "accessibilityStatement": "Saavutettavuusseloste",
    "externalLink": "Avautuu uuteen välilehteen"
  },
  "editor": {
    "identifier": "Tunniste",
    "identifierError": "Tunniste on varattu tai epäkelpo. Tunniste saa sisältää vain isoja tai pieniä aakkosia, numeroita ja _ tai - -merkkejä.",
    "title": "Nimi",
    "description": "Kuvaus (ei näy vastaajille)",
    "surveySchema": {
      "titlePlaceholder": "Kyselypohjan nimi",
      "identifierPlaceholder": "Kyselypohjan tunniste",
      "descriptionPlaceholder": "Kyselypohjan kuvaus",
      "typePlaceholder": "Valitse kyselyn tyyppi",
      "introduction": "Kyselyn oletusaloitusteksti",
      "completion": "Kyselyn oletuslopetusteksti",
      "feedbackIntroduction": "Palautteen yhteenveto",
      "feedbackIntroductionInfo": "Kyselyn sulkeuduttua vastaajat saavat yksilöllistä palautetta, joka pohjautuu osakyselyissä määriteltyihin ulottuvuuksiin. Määrittele alla olevassa kentässä koko palautenäkymän yhteenvetoteksti, jonka tarkoituksena on selittää palautenäkymän tarkoitus sekä antaa esimerkiksi lukuohje palautenäkymälle",
      "preview": {
        "newSchemaStatusExplanation": "Jos tallennat kyselypohjan Luonnos-tilassa, sitä ei vielä voi ottaa käyttöön kyselyissä. Jos tallennat kyselypohjan Valmis-tilassa, se voidaan ottaa käyttöön kyselyissä. Voit jatkaa kyselypohjan muokkaamista myöhemmin.",
        "existingSchemaStatusExplanation": "Jos tallennat kyselypohjan Luonnos-tilassa, muutoksia ei päivitetä kyselyihin, joihin osakysely on liitetty. Voit jatkaa kyselypohjan muokkaamista myöhemmin. Jos tallennat kyselypohjan Valmis-tilassa, muokattu kyselypohja otetaan käyttöön niissä kyselyissä, joihin se on liitetty ja joita ei vielä ole ajastettu."
      },
      "edit": {
        "infoTitle": "Kyselypohjan muokkaus",
        "inUseExplanation": "<p>Tämä kyselypohja on jo käytössä kyselyissä. Voit muokata palautteen yhteenvetotekstiä. Muokattu teksti päivittyy kyselyihin ja palautteisiin, joissa kyselypohja on käytössä.</p><p>Jos haluat muokata kyselypohjaan liitettyjä osakyselyitä, sinun tulee luoda kyselypohjasta uusi versio.</p>",
        "notInUseExplanation": "<p>Tätä kyselypohjaa ei ole vielä käytetty kyselyiden käynnistämiseen. Voit muokata kyselypohjaa vapaasti.</p><p>Huomaathan, että sen jälkeen kun kyselypohja on käytössä yhdessä tai useammassa kyselyssä, sinun tulee luoda kyselypohjasta uusi versio ennen kuin voit muokata kyselypohjaa.</p>"
      },
      "newVersion": {
        "infoTitle": "Kyselypohjan uusi versio",
        "infoContent": "Teit kyselypohjasta uuden version. Tallennettuasi uuden version se korvaa vanhemman version tästä kyselypohjasta. Kyselyjä aloittavat käyttäjät näkevät vain kyselypohjan viimeisimmän version. Kyselypohjan uuden version muokkaus ei vaikuta jo aloitettujen kyselyiden tietoihin."
      },
      "extraSurveyPart": "Lisäkysymykset",
      "addExtraSurveyPart": "Valitse lisäkysymykset",
      "invitationEmailTitle": "Kutsuviesti"
    },
    "surveySchemaPart": {
      "titlePlaceholder": "Osakyselyn nimi",
      "identifierPlaceholder": "Osakyselyn tunniste",
      "descriptionPlaceholder": "Osakyselyn kuvaus"
    },
    "surveySchemaPartPreview": {
      "previewDimensionCategory": "Esikatsele ulottuvuuden ${ variableName } palautekategoriaa",
      "noPreviewDimensions": "Ei esikatseltavia ulottuvuuksia.",
      "unnamedDimension": "Nimeämätön ulottuvuus",
      "unnamedCategory": "Nimeämätön kategoria",
      "noLinkedQuestions": "Ulottuvuuteen ${ variableName } ei ole liitetty kysymyksiä, joten esikatselua ei voida näyttää.",
      "connectedSchemaNotInUseExplanation": "Osakysely on käytössä kyselypohjissa, joita ei ole vielä käytetty kyselyn käynnistämiseen. Muokattu osakysely päivitetään näihin kyselypohjiin.",
      "connectedSchemaInUseExplanation": "Osakysely on käytössä kyselypohjissa, joita on jo käytetty kyselyn käynnistämiseen. Valitse kyselypohjat, joihin muokattu osakysely päivitetään. Päivityksen yhteydessä näistä kyselypohjista luodaan uudet versiot.",
      "variableQuestionsNotSelected": "Osakyselyllä on ulottuvuuksia, joille ei ole valittu väittämiä"
    },
    "surveySchemaParts": {
      "schemaParts": "Osakyselyt",
      "schemaPartsInfo": "Kyselypohja on kokonaisuus, josta kysely käynnistetään. Valitse, mistä osakyselyistä kyselypohja koostuu.",
      "editSchemaParts": "Muokkaa osakyselyitä",
      "chooseSchemaParts": "Valitse lisättävät osakyselyt",
      "loadMoreSchemaParts": "Näytä lisää osakyselyitä",
      "selectSchemaParts": "Valitse osat",
      "updateSchemaPartVersion": "Päivitä versio"
    }
  },
  "surveySchemas": {
    "title": "Kyselypohjat",
    "schema": "Kyselypohja",
    "schemas": "Kyselypohjat",
    "schemaIntroduction": "Kyselypohjat ovat osakyselyistä koottuja kokonaisuuksia, joiden pohjalta kyselyt käynnistetään.",
    "createNew": "Luo uusi kyselypohja",
    "surveySchemaList": {
      "header": {
        "name": "Nimi",
        "code": "Tunniste",
        "version": "Versio",
        "status": "Tila",
        "lastEdited": "Muokattu"
      },
      "types": {
        "DEGREE_PROGRAM_SURVEY": "HowULearn-kyselypohjat",
        "COURSE_SURVEY": "HowUStudy-kyselypohjat",
        "HUP": "PhD-kyselypohjat",
        "HUT": "HowUTeach-kyselypohjat"
      }
    }
  },
  "surveyParts": {
    "identifier": "Tunniste",
    "name": "Osakyselyn nimi",
    "required": "Pakollinen kysymys",
    "isRequired": "Kysymys on pakollinen",
    "description": "Kuvaus (ei näy vastaajille)",
    "questions": "Kysymykset",
    "nQuestionsPlural": "kysymystä",
    "nQuestionsSingular": "kysymys",
    "addElement": "Lisää elementti",
    "responseOption": {
      "empty": "Vastausvaihtoehto puuttuu"
    },
    "dropdown": {
      "addOption": "Lisää vaihtoehto",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Option"
      }
    },
    "radioButtonGroup": {
      "addOption": "Lisää valintanappi",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Option"
      }
    },
    "checkboxGroup": {
      "addOption": "Lisää valintaruutu",
      "question": {
        "fi": "Kysymys tai väittämä",
        "sv": "Fråga eller påstående",
        "en": "Question or statement"
      },
      "option": {
        "fi": "Vastausvaihtoehto",
        "sv": "Svarsalternativ",
        "en": "Option"
      }
    },
    "likert": {
      "questions": "Kysymykset tai väittämät",
      "addQuestion": "Lisää kysymys tai väittämä",
      "addValue": "Lisää arvo",
      "scale": "Asteikko",
      "scaleStartValue": "Asteikon aloitusarvo"
    },
    "itemTitles": {
      "textField": "Avoin kysymys",
      "likert": "Likert",
      "customLikert": "Mukautettu",
      "heading": "Väliotsikko",
      "instructionText": "Ohjeteksti",
      "dropdown": "Pudotusvalikko",
      "radioButtonGroup": "Valintanapit",
      "checkboxGroup": "Valintaruudut"
    },
    "titleMissing": "Ei otsikkoa",
    "descriptionMissing": "Ei kuvausta",
    "validation": {
      "question": {
        "code": {
          "invalid": "Kysymyksen tunniste \"${value}\" on epäkelpo",
          "duplicate": "Kysymyksen tunnistetta \"${value}\" on käytetty useammin kuin kerran"
        }
      }
    }
  },
  "surveySchemaParts": {
    "schemaParts": "Osakyselyt",
    "schemaPartsIntroduction": "Osakyselyt ovat valmiiksi luotuja kokoelmia tiettyyn aihepiiriin liittyvistä kysymyksistä. Osakyselyistä kootaan varsinaiset kyselypohjat.",
    "namePlaceholder": "Osakyselyn nimi",
    "identifierPlaceholder": "Osakyselyn tunniste",
    "descriptionPlaceholder": "Osakyselyn kuvaus",
    "createNew": "Luo osakysely",
    "surveyPart": "Osakysely",
    "partTitle": "Osakyselyn otsikko",
    "selectSurveyType": "Valitse kyselyn tyyppi",
    "limitedEditingInformationTitle": "Osakyselyn muokkaus",
    "limitedEditingInformation": "Tämä osakysely on jo käytössä kyselyissä. Voit muokata osakyselyn tekstejä korjataksesi kirjoitusvirheitä. Muokatut tekstit päivittyvät kyselypohjiin, joissa osakysely on käytössä sekä näistä kyselypohjista luotuihin kyselyihin. Jos haluat muokata osakyselyn rakennetta tai muuttaa kysymyksiä tai väittämiä, luo osakyselystä uusi versio.",
    "newCopyInformationTitle": "Osakyselyn kopio",
    "newCopyInformation": "Teit osakyselyn kopion. Voit muokata osakyselyn tietoja sekä poistaa, lisätä ja muokata kysymyksiä, väittämiä tai ulottuvuuksia. Kun tallennat osakyselyn kopion, se näkyy käyttäjille omana uutena osakyselynä. Huomaathan, että vaikka osakyselyn tunniste muutetaan automaattisesti, kysymysten ja väittämien tunnisteet säilyvät ennallaan. Nämä on suositeltavaa muuttaa ennen muutosten tallentamista.",
    "newVersionInformationTitle": "Osakyselyn uusi versio",
    "newVersionInformation": "Teit osakyselystä uuden version, jota voit muokata vapaasti. Tallentaessasi uuden version voit valita, missä kyselypohjissa uusi versio otetaan käyttöön. Kyselypohjan uuden version muokkaaminen ei vaikuta jo aloitettujen kyselyiden tietoihin.",
    "dimensions": {
      "dimensions": "Ulottuvuudet",
      "dimension": "Ulottuvuus",
      "name": "Ulottuvuuden nimi",
      "nameDescription": "Anna ulottuvuudelle nimi, nimi näytetään käyttäjälle palautteen yhteydessä",
      "questionsDescription": "Valitse kysymykset joiden vastauksista tämän ulottuvuuden tulos muodostuu. Huomaathan että voit valita vain likert väittämiä joilla on sama asteikko.",
      "description": "Ulottuvuuden kuvaus",
      "descriptionDescription": "Tämä yhteinen osuus näytetään kaikille vastaajille",
      "add": "Lisää ulottuvuus",
      "type": {
        "relative": "Ulottuvuus - keskiarvo",
        "absolute": "Ulottuvuus - normi"
      },
      "relativeFeedback": {
        "belowAverage": "Alle keskiarvon",
        "average": "Keskiarvo",
        "overAverage": "Yli keskiarvon",
        "feedback": "Palaute suhteessa keskiarvoon",
        "improvementSuggestion": "Vinkit kehittymiseen",
        "previewImageAlt": "Palaute suhteessa keskiarvoon visualisaatio",
        "categoryError": "Kategoriaa ${category} ei tunnistettu validiksi palautekategoriaksi"
      },
      "absoluteFeedback": {
        "values": "Normatiivinen asteikko",
        "valuesDescription": "Määrittele normatiivisen ulottuvuuden asteikko, jonka arvoihin käyttäjän vastausten kokonaispistemäärää verrataan. Alla olevissa välilehdissä voit määritellä asteikkoa vastaavat yksilölliset palautteet.",
        "addValue": "Lisää arvo",
        "feedback": "Arvosi suhteessa normiin",
        "improvementSuggestion": "Tulosten tulkinta"
      },
      "extraInfo": {
        "heading": "Lisätiedot",
        "title": "Muokattavat lisätiedot",
        "description": "Lisätiedot liitetään ulottuvuuteen ja näytetään lopulta kyselyosallistujille kyselyn tuloksissa. Voit antaa lisätiedon kolmella kielellä.",
        "edit": "Muokkaa lisätietoja",
        "editDescription": "Olet muokkaamassa lisätietoja osakyselyn ulottuvuuteen <strong>${ dimensionName }</strong>. Lisätiedot liitetään ulottuvuuteen, ja ne näytetään lopulta kyselyosallistujille kyselyn tuloksissa.",
        "delete": "Tyhjennä lisätiedot",
        "deleteConfirmation": "Tahdotko varmasti tyhjentää kaikki ulottuvuudelle annetut lisätiedot?",
        "titlefi": "Otsikko (FI)",
        "titlesv": "Otsikko (SV)",
        "titleen": "Otsikko (EN)",
        "infofi": "Lisätiedot (FI)",
        "infosv": "Lisätiedot (SV)",
        "infoen": "Lisätiedot (EN)",
        "noExtraInfo": "Ei lisätietoja annettu",
        "requiredDescription": "Kentät ovat pakollisia vähintään yhdellä kielellä"
      }
    },
    "schemaPartCount": "osakyselyä",
    "browse": "Selaa osakyselyitä",
    "search": {
      "heading": "Hae ja rajaa",
      "titleSearch": "Hae nimellä tai tunnisteella",
      "filter": "Rajaa",
      "filterOptions": {
        "selfMade": "Vain itse luodut"
      }
    },
    "selectedSchemaPartTitle": "Valitut osakyselyt",
    "noSelectedSchemaParts": "Ei valittuja osakyselyitä",
    "noSelectedSchemaPart": "Ei valittua osakyselyä",
    "preview": {
      "newSurveyPartStateExplanation": "Jos tallennat osakyselyn Luonnos-tilassa, se voidaan ottaa käyttöön kyselypohjissa, jotka ovat myös Luonnos-tilassa. Jos tallennat osakyselyn Valmis-tilassa, se voidaan ottaa käyttöön myös kyselypohjissa, jotka ovat Valmis-tilassa. Voit jatkaa osakyselyn muokkaamista myöhemmin.",
      "existingSurveyPartStateExplanation": "Jos tallennat osakyselyn Luonnos-tilassa, muutoksia ei päivitetä kyselypohjiin, joihin osakysely on liitetty. Voit jatkaa osakyselyn muokkaamista myöhemmin. Jos tallennat kyselyn Valmis-tilassa, muokattu osakysely otetaan käyttöön niissä kyselypohjissa, joihin se on liitetty."
    },
    "extraSurveyPart": "Lisäkysymykset"
  },
  "extraSurveyParts": {
    "title": "Lisäkysymysjoukot",
    "createNew": "Luo lisäkysymysjoukko",
    "loadMore": "Näytä lisää lisäkysymyksiä",
    "extraPartsIntroduction": "Lisäkysymysjoukko on ennalta määritelty kysymysjoukko, joka voidaan liittää aloitettavan kyselyn loppuun. Lisäkysymyksillä voidaan täydentää kyselypohjaa kyselykohtaisesti.",
    "surveyPart": "Lisäkysymysjoukko",
    "namePlaceholder": "Lisäkysymysjoukon nimi",
    "identifierPlaceholder": "Lisäkysymysjoukon tunniste",
    "descriptionPlaceholder": "Lisäkysymysjoukon kuvaus",
    "partTitle": "Lisäkysymysjoukon otsikko",
    "newCopyInformationTitle": "Lisäkysymysjoukon kopio",
    "newCopyInformation": "Teit kopion lisäkysymysjoukosta. Voit muokata kopion lisäkysymyksiä vapaasti ilman, että se vaikuttaa alkuperäisiin lisäkysymyksiin tai kyselyihin, jotka käyttävät niitä. Huomaathan, että vaikka osakyselyn tunniste muutetaan automaattisesti, kysymysten ja väittämien tunnisteet säilyvät ennallaan. Nämä on suositeltavaa muuttaa ennen muutosten tallentamista.",
    "limitedEditingInformation": "Nämä lisäkysymykset ovat jo käytössä kyselyssä. Voit muokata osakyselyn tekstejä korjataksesi kirjoitusvirheitä. Muokatut tekstit päivittyvät myös käynnissä oleviin kyselyihin. Jos haluat muokata osakyselyn rakennetta tai muuttaa kysymyksiä tai väittämiä, luo uusi lisäkysymysjoukko.",
    "limitedEditingInformationTitle": "Lisäkysymysten muokkaus",
    "selectedSchemaPartTitle": "Valittu lisäkysymysjoukko",
    "noSelectedSchemaPart": "Ei valittua lisäkysymysjoukkoa",
    "preview": {
      "newSurveyPartStateExplanation": "Jos tallennat lisäkysymysjoukon Julkaistu-tilassa, se voidaan ottaa käyttöön kyselyissä. Voit jatkaa lisäkysymysjoukon muokkaamista myöhemmin.",
      "existingSurveyPartStateExplanation": "Jos tallennat lisäkysymysjoukon Julkaistu-tilassa, se voidaan ottaa käyttöön kyselyissä. Voit jatkaa lisäkysymysjoukon muokkaamista myöhemmin."
    },
    "browse": "Selaa lisäkysymysjoukkoja",
    "searchResult": "Valintoja vastaavat lisäkysymysjoukot",
    "extraPartCount": "lisäkysymystä",
    "sensitiveInfoNotification": "Ethän kysy terveystietoja tai muita arkaluontoisia tietoja"
  },
  "manageSurveys": {
    "openSurveys": "Avoimet kyselyt",
    "hulSurveys": "HowULearn-kyselyt",
    "husSurveys": "HowUStudy-kyselyt",
    "hupSurveys": "PhD-kyselyt",
    "hutSurveys": "HowUTeach-kyselyt",
    "openStudyProgramSurveys": "Avoimet HowULearn-kyselyt",
    "openCourseSurveys": "Avoimet HowUStudy-kyselyt",
    "closedSurveys": "Suljetut kyselyt",
    "closedStudyProgramSurveys": "Suljetut HowULearn-kyselyt",
    "closedCourseSurveys": "Suljetut HowUStudy-kyselyt",
    "confirmCloseSurvey": "Vahvista kyselyn sulkeminen",
    "nSurveys": "kyselyä",
    "nParticipants": "${ count } osallistujaa",
    "nSurveySchemas": "kyselypohjaa",
    "showArchived": "Näytä arkistoidut",
    "state": "Tila",
    "responseTime": "Vastausaika",
    "numberOfResponses": "Vastauksia",
    "quickSteps": "Pikatoiminnot",
    "addParticipant": "Lisää osallistuja",
    "removeParticipant": "Poista osallistuja",
    "removeParticipantConfirm": "Haluatko varmasti poistaa osallistujan?",
    "removeAnswers": "Poista vastaukset",
    "removeAnswersConfirm": "Haluatko varmasti poistaa osallistujan vastaukset?",
    "participants": "Osallistujat",
    "closeSurvey": "Sulje kysely",
    "editScheduling": "Muokkaa ajoitusta",
    "notEnoughResponses": "Ei riittävästi vastauksia",
    "closeSurveyAreYouSure": "Oletko varma, että haluat sulkea kyselyn? Voit avata suljetun kyselyn halutessasi uudestaan suljetun kyselyn toiminnoista.",
    "browseSurveys": "Selaa kyselyitä",
    "startSurvey": "Käynnistä kysely",
    "reopen": {
      "title": "Avaa kysely",
      "description": "Määrittele uudelleen avattavalle kyselylle päättymisajankohta ja palautteen aukeamisajankohta. Avattuasi kyselyn voit lisätä ja poistaa osallistujia tai lähettää kyselystä muistutusviestin.",
      "doNotSendStartNotification": "Älä lähetä kutsuviestiä",
      "newParticipants": {
        "title": "Uudet vastaanottajat",
        "description": "Voit lisätä kyselyyn uusia osallistujia, jotka saavat kutsun kyselyyn. Uudelleen avattuun kyselyyn voivat vastata myös ne aiemmin kutsutut osallistujat, jotka eivät vielä ole vastanneet kyselyyn."
      }
    },
    "scheduling": {
      "title": "Muokkaa kyselyn ajoitusta",
      "reminderMessageInfo": "Tiedota kyselyyn osallistuvia opiskelijoita kyselyn uudesta sulkeutumisajasta.",
      "saveAndSendMessage": "Tallenna ja lähetä",
      "surveyRescheduledAndReminderSent": "Kyselyn uudeksi sulkeutumisajaksi asetettu ${ endDate } ja ilmoitus tästä lähetetty kaikille osallistujille."
    },
    "search": {
      "title": "haku",
      "hide": "Piilota haku",
      "titleSearchPlaceholder": "Etsi kyselyn nimellä",
      "degreeProgramSearchPlaceholder": "Kohderyhmä",
      "surveyStartedAfterPlaceholder": "Alkamispäivä jälkeen",
      "surveyStartedBeforePlaceholder": "Alkamispäivä ennen",
      "stateSearchPlaceholder": "Kyselyn tila",
      "surveyNameLabel": "Kyselyn nimi"
    }
  },
  "surveyStatistics": {
    "responseCount": "Vastauksia",
    "openQuestionCount": "Avokysymyksiä tällä kyselyllä:",
    "researchConsentGivenCount": "Tutkimuslupia",
    "reminderSentAt": "Muistutusviesti lähetetty",
    "feedbackViewCount": "Palautteen katsoneet",
    "feedbackViewCountDisclaimer": "Seurantatietojen kerääminen aloitettu 9.12.2019",
    "smallest": "Pienin",
    "largest": "Suurin",
    "noStatsUntilClosed": "Kyselyn tulokset voidaan näyttää vasta kun kysely on suljettu.",
    "notEnoughResponses": "Kyselyn tuloksia ei voida näyttää, koska vastauksia ei ole riittävästi.",
    "computingStatistics": "Kyselyn tuloksia ei voida näyttää, koska niitä lasketaan vielä,",
    "dimensions": "Ulottuvuudet",
    "otherAnswers": "Muiden vastausten jakaumat",
    "answerDistributions": "Vastausten jakaumat",
    "extraQuestions": "Lisäkysymykset",
    "responseDistribution": "Tulosten tulkinnan avuksi",
    "responsesToOpenQuestions": "Vastaukset avoimiin kysymyksiin",
    "dimensionStatements": "Ulottuvuuden väittämät",
    "statisticsComputedAt": "Tilastot laskettu",
    "reminderTimes": "Ajastetut muistutusviestit",
    "viewOpenQuestionResponseReport": "Näytä avoimien kysymysten vastaukset"
  },
  "feedbackBox": {
    "feedback": "Ota yhteyttä",
    "placeholder": "Ota yhteyttä tai anna palautetta palvelusta...",
    "submit": "Lähetä",
    "thanks": "Kiitos"
  },
  "surveyResponseTimeEnd": {
    "warning": "Huomaathan, että kysely sulkeutuu klo ${endTime}, jonka jälkeen vastausta ei enää oteta vastaan.",
    "timeout": "Kysely ehti sulkeutua, vastauksiasi ei voitu tallentaa."
  },
  "textInput": {
    "maxLength": "Kentän maksimimerkkimäärä on "
  },
  "status": {
    "DRAFT": "Luonnos",
    "PUBLISHED": "Valmis",
    "IN_USE": "Käytössä",
    "NOTUSED": "Ei käytössä",
    "ARCHIVED": "Arkistoitu"
  },
  "actions": {
    "archive": "Arkistoi",
    "confirmArchiveSurveySchema": "Oletko varma että haluat arkistoida kyselypohjan? Arkistoitua kyselypohjaa ei voi enää käyttää uusien kyselyiden luomiseen.",
    "viewVersionHistory": "Selaa versioita",
    "createNewCopy": "Luo uusi kopio",
    "createNewVersion": "Luo uusi versio",
    "edit": "Muokkaa"
  },
  "environment": {
    "info": {
      "demo": "Huomio! Tämä on demoympäristö."
    }
  },
  "permissionManagement": {
    "title": "Käyttöoikeuksien hallinta",
    "basicInfo": "Perustiedot",
    "description": "Käyttöoikeuksien hallinta",
    "user": "Käyttäjä",
    "saveSuccess": "Muutokset tallennettu onnistuneesti",
    "role": "Rooli",
    "generalRoles": "Yleiset roolit",
    "surveyRoles": "Kyselyroolit",
    "noRole": "Ei roolia",
    "anyRole": "Mikä tahansa rooli",
    "all": "Kaikki",
    "searchUsers": "Hae käyttäjiä",
    "roleFilters": "Roolirajaus",
    "searchFilter": "Hakurajaus",
    "clearFilters": "Poista rajaukset"
  },
  "activityLog": {
    "activityLog": "Aktiviteettiloki",
    "action": "Toiminto",
    "exportReason": "Tietojen käyttötarkoitus",
    "EXPORT_DATA": "Export",
    "EXPORT_SENSITIVE_DATA": "Tutkimusexport"
  },
  "MESSAGES": {
    "defaultSurveyInvitationTitle": {
      "DEGREE_PROGRAM_SURVEY": "Kutsu HowULearn–kyselyyn",
      "COURSE_SURVEY": "Kutsu HowUStudy–kyselyyn",
      "HUP": "Kutsu PhD-kyselyyn",
      "HUT": "Kutsu HowUTeach-kyselyyn"
    },
    "defaultSurveyInvitationContent": {
      "DEGREE_PROGRAM_SURVEY": "Hei!\n\nTervetuloa vastaamaan oppimista ja opiskelua koskevaan HowULearn-kyselyyn. HowULearn-kyselyillä tuetaan opiskelijoiden oppimista ja opiskelua sekä opetuksen laadun kehittämistä.\n\nKyselyn päätyttyä saat henkilökohtaisen palautteen, jotka perustuvat antamiisi kyselyvastauksiin. Palautteet sisältävät korkeakoulupedagogiikan tutkijoiden ja asiantuntijoiden sekä opintopsykologien laatimia vinkkejä opiskelusi tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyyn osallistuneet opiskelijat vastasivat kyselyn eri osa-alueisiin.\n\nUniHow-palvelu muodostaa kyselyvastauksista myös koosteen, jossa vastauksia käsitellään ryhmätasolla. Kyselyn palautteen pohjalta koulutuksen järjestäjän, opettajien ja koulutuksen johdon on mahdollista kehittää opetusta tukemaan opiskelijoiden opiskelua ja opetuksen laatua entistä paremmin.\n\nPääset vastaamaan kyselyyn kirjautumalla palveluun korkeakoulusi käyttäjätunnuksella. Kun kysely on sulkeutunut, voit tutustua tuloksiin UniHow-palvelussa.\n\nSiirry kyselyyn: [QUESTIONNAIRE_LINK_TAG]\n\nVastaa kyselyyn [QUESTIONNAIRE_END_DATE_TAG] mennessä.\n\nKiitos osallistumisesta jo etukäteen!\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\n\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "Hei!\n\nTervetuloa vastaamaan oppimista ja opiskelua koskevaan HowULearn-kyselyyn. HowULearn-kyselyillä tuetaan opiskelijoiden oppimista ja opiskelua sekä opetuksen laadun kehittämistä.\n\nKyselyn päätyttyä saat henkilökohtaiset palautteen, jotka perustuvat antamiisi kyselyvastauksiin. Palautteet sisältävät korkeakoulupedagogiikan tutkijoiden ja asiantuntijoiden sekä opintopsykologien laatimia vinkkejä opiskelusi tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyyn osallistuneet opiskelijat vastasivat kyselyn eri osa-alueisiin.\n\nUniHow-palvelu muodostaa kyselyvastauksista myös koosteen, jossa vastauksia käsitellään ryhmätasolla. Kyselyn palautteen pohjalta koulutuksen järjestäjän, opettajien ja koulutuksen johdon on mahdollista kehittää opetusta tukemaan opiskelijoiden opiskelua ja opetuksen laatua entistä paremmin.\n\nPääset vastaamaan kyselyyn kirjautumalla palveluun korkeakoulusi käyttäjätunnuksella. Kun kysely on sulkeutunut, voit tutustua tuloksiin UniHow-palvelussa.\n\nSiirry kyselyyn: [QUESTIONNAIRE_LINK_TAG]\n\nVastaa kyselyyn [QUESTIONNAIRE_END_DATE_TAG] mennessä.\n\nKiitos osallistumisesta jo etukäteen!\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\n\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n",
      "HUP": "Hei!\n\nTervetuloa vastaamaan PhD-kyselyyn, jossa tarkastellaan kokemuksiasi väitöskirjatutkimusprosessista. PhD-kyselyn tavoitteena on auttaa sinua jäsentämään kokemuksiasi väitöskirjatutkimuksen tekemisestä ja tunnistamaan siihen vaikuttavia tekijöitä. Kyselyn tuloksia hyödynnetään tohtorikoulutuksen kehittämissä.\n\nKyselyn päätyttyä saat vastauksiisi perustuvan henkilökohtaisen palautteen. Palaute sisältää tohtorikoulutuksen tutkijoiden ja asiantuntijoiden kokoamaa tietoa ja vinkkejä väitöskirjaprosessisi tueksi. Lisäksi näet, miten vastauksesi suhteutuvat muiden väitöskirjatutkijoiden vastauksiin.\n\nUniHow-palvelu muodostaa kyselyvastauksista koosteen, jossa vastauksia käsitellään ryhmätasolla. Kyselyn palautteen pohjalta tohtorikoulutusta on mahdollista kehittää siten, että se tukee paremmin väitöskirjatutkijoiden etenemistä ja hyvinvointia. Pääset vastaamaan kyselyyn kirjautumalla palveluun korkeakoulusi käyttäjätunnuksella. Kun kysely on sulkeutunut, voit tutustua tuloksiin UniHow-palvelussa.\n\nSiirry kyselyyn: [QUESTIONNAIRE_LINK_TAG]\n\nVastaa kyselyyn [QUESTIONNAIRE_END_DATE_TAG] mennessä.\n\nKiitos osallistumisesta jo etukäteen! Tämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin. UniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\n\nLisätietoja Funidatasta ja UniHow:sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.",
      "HUT": "Hei!\n\nTervetuloa vastaamaan opetusta koskevaan HowUTeach-kyselyyn.\n\nKyselyn päätyttyä saat henkilökohtaiset palautteen, jotka perustuvat antamiisi kyselyvastauksiin. Palautteet sisältävät korkeakoulupedagogiikan tutkijoiden ja asiantuntijoiden laatimia vinkkejä opetuksesi tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyosallistujat vastasivat kyselyn eri osa-alueisiin.\n\nUniHow-palvelu muodostaa kyselyvastauksista myös koosteen, jossa vastauksia käsitellään ryhmätasolla.\n\nPääset vastaamaan kyselyyn kirjautumalla palveluun korkeakoulusi käyttäjätunnuksella. Kun kysely on sulkeutunut, voit tutustua tuloksiin UniHow-palvelussa.\n\nSiirry kyselyyn: [QUESTIONNAIRE_LINK_TAG]\n\nVastaa kyselyyn [QUESTIONNAIRE_END_DATE_TAG] mennessä.\n\nKiitos osallistumisesta jo etukäteen!\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\n\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n"
    },
    "defaultSurveyEndedTitle": {
      "DEGREE_PROGRAM_SURVEY": "HowULearn-palautteesi on nyt luettavissa",
      "COURSE_SURVEY": "",
      "HUP": "PhD-kyselypalautteesi on luettavissa",
      "HUT": "HowUTeach-palautteesi on nyt luettavissa"
    },
    "defaultSurveyEndedContent": {
      "DEGREE_PROGRAM_SURVEY": "Hei!\n\nOlet vastannut oppimista ja opiskelua koskevaan HowULearn-kyselyyn. Tutustu tuloksiin UniHow-palvelussa osoitteessa [QUESTIONNAIRE_FEEDBACK_LINK_TAG]\n\nPalautteet perustuvat antamiisi kyselyvastauksiin. Palautteet sisältävät korkeakoulupedagogiseen tutkimukseen perustuvia vinkkejä opiskelun tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyyn osallistuneet opiskelijat vastasivat kyselyn eri osa-alueisiin.\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "",
      "HUP": "Hei!\n\nOlet vastannut PhD-kyselyyn, jossa tarkasteltiin kokemuksiasi väitöskirjaprosessista. Tutustu tuloksiin UniHow-palvelussa osoitteessa [QUESTIONNAIRE_FEEDBACK_LINK_TAG].\n\nPalautteet perustuvat antamiisi kyselyvastauksiin. Palautteet sisältävät tohtorikoulutuksen tutkimukseen perustuvia vinkkejä väitöskirjatyösi tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyyn osallistuneet väitöskirjatutkijat vastasivat kyselyn eri osa-alueisiin.\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n",
      "HUT": "Hei!\n\nOlet vastannut opetusta koskevaan HowUTeach-kyselyyn. Tutustu tuloksiin UniHow-palvelussa osoitteessa [QUESTIONNAIRE_FEEDBACK_LINK_TAG]\n\nPalautteet perustuvat antamiisi kyselyvastauksiin. Palautteet sisältävät korkeakoulupedagogiseen tutkimukseen perustuvia vinkkejä opetuksen tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyyn osallistuneet opiskelijat vastasivat kyselyn eri osa-alueisiin.\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n"
    },
    "defaultSurveyReminderTitle": {
      "DEGREE_PROGRAM_SURVEY": "Kutsu HowULearn–kyselyyn",
      "COURSE_SURVEY": "",
      "HUP": "Kutsu PhD–kyselyyn",
      "HUT": "Kutsu HowUTeach-kyselyyn"
    },
    "defaultSurveyReminderContent": {
      "DEGREE_PROGRAM_SURVEY": "Hei!\n\nEt ole vielä käynyt vastaamassa oppimista ja opetusta koskevaan HowULearn-kyselyyn.\n\nHowULearn-kyselyillä tuetaan opiskelijoiden oppimista ja opiskelua sekä opetuksen laadun kehittämistä. Kyselyn päätyttyä saat henkilökohtaiset palautteet, jotka perustuvat antamiisi vastauksiin. \n\nPääset vastaamaan kyselyyn kirjautumalla palveluun korkeakoulusi käyttäjätunnuksella.\n\nSiirry kyselyyn: [QUESTIONNAIRE_LINK_TAG]\n\nVastaa kyselyyn [QUESTIONNAIRE_END_DATE_TAG] mennessä.\n\nKiitos osallistumisestasi jo etukäteen!\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\n\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\n\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n",
      "COURSE_SURVEY": "Hei!\n\nEt ole vielä käynyt vastaamassa oppimista ja opetusta koskevaan HowULearn-kyselyyn.\n\nHowULearn-kyselyillä tuetaan opiskelijoiden oppimista ja opiskelua sekä opetuksen laadun kehittämistä. Kyselyn päätyttyä saat henkilökohtaiset palautteet, jotka perustuvat antamiisi vastauksiin. \n\nPääset vastaamaan kyselyyn kirjautumalla palveluun korkeakoulusi käyttäjätunnuksella.\n\nSiirry kyselyyn: [QUESTIONNAIRE_LINK_TAG]\n\nVastaa kyselyyn [QUESTIONNAIRE_END_DATE_TAG] mennessä.\n\nKiitos osallistumisestasi jo etukäteen!\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\n\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\n\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n",
      "HUP": "Hei!\n\nEt ole vielä käynyt vastaamassa väitöskirjatutkijoiden kokemuksia koskevaan PhD-kyselyyn.\n\nPhD-kyselyn tavoitteena on auttaa sinua jäsentämään kokemuksiasi väitöskirjatutkimuksen tekemisestä ja tunnistamaan siihen vaikuttavia tekijöitä. Kyselyn tuloksia hyödynnetään tohtorikoulutuksen kehittämissä. Kyselyn päätyttyä saat henkilökohtaiset palautteet, jotka perustuvat antamiisi vastauksiin.\n\nPääset vastaamaan kyselyyn kirjautumalla palveluun korkeakoulusi käyttäjätunnuksella.\n\nSiirry kyselyyn: [QUESTIONNAIRE_LINK_TAG]\n\nVastaa kyselyyn [QUESTIONNAIRE_END_DATE_TAG] mennessä.\n\nKiitos osallistumisestasi jo etukäteen!\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\n\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\n\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n",
      "HUT": "Hei!\n\nEt ole vielä käynyt vastaamassa opetusta koskevaan HowUTeach-kyselyyn.\n\nKyselyn päätyttyä saat henkilökohtaiset palautteet, jotka perustuvat antamiisi vastauksiin.\n\nPääset vastaamaan kyselyyn kirjautumalla palveluun korkeakoulusi käyttäjätunnuksella.\n\nSiirry kyselyyn: [QUESTIONNAIRE_LINK_TAG]\n\nVastaa kyselyyn [QUESTIONNAIRE_END_DATE_TAG] mennessä.\n\nKiitos osallistumisestasi jo etukäteen!\n\nTämä viesti on UniHow-palvelun automaattisesti lähettämä. Et voi vastata viestiin.\n\nUniHow on suomalainen oppimisen ja opetuksen kehittämisen tukiväline, jota Funidata Oy ja Helsingin yliopisto kehittävät yhteistyössä.\n\nLisätietoja Funidatasta ja UniHow'sta löydät verkkosivuilta: https://funidata.fi/palvelut/unihow.\n"
    },
    "defaultSurveyIntroduction": {
      "DEGREE_PROGRAM_SURVEY": "<p>Tervetuloa vastaamaan HowULearn-kyselyyn!</p><p>HowULearn-kyselyn avulla on tarkoitus saada tietoa opiskelijoiden opiskelusta ja opetuksesta. Pohdi omaa opiskeluasi, oppimistasi ja nykyistä opiskelutilannettasi. HowULearnin kysymykset ja väittämät perustuvat korkeakouluoppimista ja -opetusta koskevaan tutkimukseen. Kysymyksiin ei ole hyviä tai huonoja vastauksia. Vastaathan jokaiseen kysymykseen parhaasi mukaan ja niin vilpittömästi kuin mahdollista.</p><p>Kyselyn päätyttyä saat henkilökohtaisen palautteen, joka perustuu antamiisi vastauksiin. Palaute sisältää korkeakoulupedagogiikan tutkijoiden ja asiantuntijoiden sekä opintopsykologien laatimia vinkkejä opiskelun tueksi.</p>",
      "COURSE_SURVEY": "",
      "HUP": "<p><p>Tervetuloa vastaamaan PhD-kyselyyn!</p><p> PhD-kyselyn avulla saadaan tietoa väitöskirjatutkijoiden kokemuksista väitöskirjatutkimuksen tekemisestä. Kyselyn kysymykset ja väittämät perustuvat tohtorikoulutuksen tutkimukseen. Kysymyksiin ei ole hyviä tai huonoja vastauksia. Kyselyyn vastaaminen vie noin 15-20 minuuttia. Kun kyselyn vastausaika päättyy, järjestelmä antaa sinulle palautetta vastauksistasi. Palaute sisältää tietoa ja vinkkejä, jotka voivat auttaa sinua jäsentämään kokemuksiasi väitöskirjatutkimuksen tekemisestä ja tunnistamaan siihen vaikuttavia tekijöitä. Palaute perustuu tohtorikoulutuksen tutkimukseen. Palautteesi tulee vain sinun nähtävillesi. Kerättyjä tietoja hyödynnetään ainoastaan tilastollisesti ryhmätasolla, eikä yksittäisen vastaajan vastauksia raportoida.</p>",
      "HUT": "<p>Tervetuloa vastaamaan HowUTeach-kyselyyn!</p><p>HowUTeach-kyselyn avulla on tarkoitus saada tietoa opettajien kokemuksista omasta opetuksesta, työyhteisöstä ja hyvinvoinnista. HowUTeachin kysymykset ja väittämät perustuvat korkeakouluoppimista ja -opetusta koskevaan tutkimukseen. Kysymyksiin ei ole hyviä tai huonoja vastauksia. Vastaathan jokaiseen kysymykseen parhaasi mukaan ja niin vilpittömästi kuin mahdollista.</p><p>Kyselyn päätyttyä saat henkilökohtaisen palautteen, joka perustuu antamiisi vastauksiin. Palaute sisältää korkeakoulupedagogiikan tutkijoiden ja asiantuntijoiden laatimia vinkkejä opetuksen tueksi."
    },
    "defaultSurveyConclusion": {
      "DEGREE_PROGRAM_SURVEY": "<p>Kiitos osallistumisesta!</p><p>Kyselyn sulkeuduttua pääset tutustumaan tuloksiin, jotka perustuvat antamiisi vastauksiin. Palautteet sisältävät korkeakoulupedagogiikan tutkijoiden ja asiantuntijoiden sekä opintopsykologien laatimia vinkkejä opiskelun tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyyn osallistuneet opiskelijat vastasivat kyselyn eri osa-alueisiin.</p><p>Palvelu muodostaa vastauksista myös koosteen, jossa vastauksia käsitellään ryhmätasolla. Kyselyn palautteen pohjalta koulutuksen järjestäjän, opettajiesi ja koulutuksen johdon on mahdollista kehittää opetusta tukemaan entistä paremmin opiskelijoiden opiskelua ja opetuksen laatua.</p><p>Saat sähköpostiisi viestin, kun palautteesi on luettavissa UniHow-palvelussa.</p>",
      "COURSE_SURVEY": "",
      "HUP": "<p>Kiitos osallistumisesta!</p><p>Kyselyn sulkeuduttua pääset tutustumaan tuloksiin, jotka perustuvat antamiisi vastauksiin. Palautteet sisältävät tohtorikoulutuksen tutkijoiden ja asiantuntijoiden laatimia vinkkejä väitöskirjatyösi tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyyn osallistuneet väitöskirjatutkijat vastasivat kyselyn eri osa-alueisiin.</p><p>Palvelu muodostaa vastauksista myös koosteen, jossa vastauksia käsitellään ryhmätasolla. Kyselyn palautteen pohjalta tohtorikoulutusta voidaan kehittää siten, että se tukee entistä paremmin väitöskirjatutkijoiden etenemistä ja hyvinvointia.</p><p>Saat sähköpostiisi viestin, kun palautteesi on luettavissa UniHow-palvelussa.</p>",
      "HUT": "<p>Kiitos osallistumisesta!</p><p>Kyselyn sulkeuduttua pääset tutustumaan tuloksiin, jotka perustuvat antamiisi vastauksiin. Palautteet sisältävät korkeakoulupedagogiikan tutkijoiden ja asiantuntijoiden laatimia vinkkejä opetuksen tueksi. Lisäksi voit verrata omia vastauksiasi siihen, miten muut kyselyosallistujat vastasivat kyselyn eri osa-alueisiin.</p><p>Palvelu muodostaa vastauksista myös koosteen, jossa vastauksia käsitellään ryhmätasolla.</p><p>Saat sähköpostiisi viestin, kun palautteesi on luettavissa UniHow-palvelussa.</p>"
    },
    "likert5DefaultOptions": {
      "1": "Täysin eri mieltä",
      "2": "Eri mieltä",
      "3": "En samaa enkä eri mieltä",
      "4": "Samaa mieltä",
      "5": "Täysin samaa mieltä"
    },
    "likert6DefaultOptions": {
      "1": "Täysin eri mieltä",
      "2": "Eri mieltä",
      "3": "Osittain eri mieltä",
      "4": "Osittain samaa mieltä",
      "5": "Samaa mieltä",
      "6": "Täysin samaa mieltä"
    },
    "likert7DefaultOptions": {
      "1": "Täysin eri mieltä",
      "2": "Eri mieltä",
      "3": "Osittain eri mieltä",
      "4": "En samaa enkä eri mieltä",
      "5": "Osittain samaa mieltä",
      "6": "Samaa mieltä",
      "7": "Täysin samaa mieltä"
    },
    "likertDefaultOptions": {
      "agree": "Täysin samaa mieltä",
      "neutral": "En samaa enkä eri mieltä",
      "disagree": "Täysin eri mieltä"
    },
    "defaultRelativeFeedback": "Oma tuloksesi oli {{USER_RESULT}} kun koko ryhmän keskiarvo oli {{GROUP_RESULT}}.",
    "defaultFeedbackIntroductionContent": {
      "DEGREE_PROGRAM_SURVEY": "Olet vastannut HowULearn-kyselyyn, jossa tiedusteltiin mm. opiskeluun ja oppimiseen liittyviä mieltymyksiäsi ja tapojasi. Kysely antaa tietoa omasta tavastasi opiskella ja kokemuksistasi oppimisympäristöstä suhteessa koko ryhmän vastauksiin.\n\nTuloksissasi näet ensin, miten olet vastannut kyselyn eri ulottuvuuksiin. Vastaustesi perusteella saat palautetta siitä, millä tavoin vastauksesi heijastavat ulottuvuuksia. Ulottuvuudet muodostuvat useasta eri väittämistä eivätkä yksittäisistä väittämistä. Muista, että vastaukset perustuvat omaan tulkintaasi omasta oppimisestasi. Kyse ei ole pysyvistä ominaisuuksista. Voit hyödyntää palautetta omien opiskelutaitojesi kehittämisessä.\n",
      "COURSE_SURVEY": "Olet vastannut HowULearn-kyselyyn, jossa tiedusteltiin mm. opiskeluun ja oppimiseen liittyviä mieltymyksiäsi ja tapojasi. Kysely antaa tietoa omasta tavastasi opiskella ja kokemuksistasi oppimisympäristöstä suhteessa koko ryhmän vastauksiin.\n\nTuloksissasi näet ensin, miten olet vastannut kyselyn eri ulottuvuuksiin. Vastaustesi perusteella saat palautetta siitä, millä tavoin vastauksesi heijastavat ulottuvuuksia. Ulottuvuudet muodostuvat useasta eri väittämistä eivätkä yksittäisistä väittämistä. Muista, että vastaukset perustuvat omaan tulkintaasi omasta oppimisestasi. Kyse ei ole pysyvistä ominaisuuksista. Voit hyödyntää palautetta omien opiskelutaitojesi kehittämisessä.\n",
      "HUP": "Olet vastannut PhD-kyselyyn, jossa tarkasteltiin kokemuksiasi väitöskirjaopinnoistasi. Kysely voi auttaa sinua ymmärtämään kokemuksiasi myös suhteessa toisten väitöskirjatutkijoiden kokemuksiin.\n\nPalautteessa näet ensin, mitä olet vastannut kyselyn eri ulottuvuuksiin suhteessa toisiin väitöskirjatutkijoihin. Tämä palaute perustuu kutakin teemaa koskeviin väittämiin, ei yksittäisiin väittämiin. Palautteen jälkeen saat tietoa ja vinkkejä seuraavista teemoista: 1) motivaatio, 2) ohjaajan tuki, 3) tiedeyhteisön tuki, 4) tutkimusinnostus ja 5) jatko-opintouupumus. Kokemuksesi väitöskirjatutkimuksen tekemisestä voi vaihdella prosessin eri vaiheissa. Voit hyödyntää palautetta oman jatko-opintopolkusi tukena.",
      "HUT": "Olet vastannut HowUTeach-kyselyyn.\n\nTuloksissasi näet ensin, miten olet vastannut kyselyn eri ulottuvuuksiin. Vastaustesi perusteella saat palautetta siitä, millä tavoin vastauksesi heijastavat ulottuvuuksia. Ulottuvuudet muodostuvat useasta eri väittämistä eivätkä yksittäisistä väittämistä. Muista, että vastaukset perustuvat omaan tulkintaasi omasta opetuksestasi. Kyse ei ole pysyvistä ominaisuuksista. Voit hyödyntää palautetta opetuksesi kehittämisessä.\n"
    },
    "researchAgreement": {
      "petition": {
        "DEGREE_PROGRAM_SURVEY": "<p>Pyydämme lupaa käyttää vastauksiasi tutkimuksessa, jossa selvitetään opiskelijoiden oppimista ja heidän kokemuksiaan oppimisympäristöistä. Tutkimuskäytön yhteydessä opintotietojärjestelmän opintosuoritus- ja opiskeluoikeustietoja sekä UniHow-järjestelmän lokitietoja (tarkemmin määritelty tietosuojailmoituksessa) voidaan yhdistää tässä kyselyssä antamiisi vastauksiin. Yksittäisten opiskelijoiden tietoja ei tulla missään vaiheessa raportoimaan. Aineistot käsitellään, analysoidaan ja säilytetään luottamuksellisesti. Palautteet raportoidaan hyviä tieteellisiä käytäntöjä noudattaen.</p><p>Tutkimusluvan antaminen on täysin vapaaehtoista, eikä sen antaminen vaikuta saamaasi vastapalautteeseen. Tutkimusluvan voi myös peruuttaa.</p>",
        "COURSE_SURVEY": "<p>Pyydämme lupaa käyttää vastauksiasi tutkimuksessa, jossa selvitetään opiskelijoiden oppimista ja heidän kokemuksiaan oppimisympäristöistä. Tutkimuskäytön yhteydessä opintotietojärjestelmän opintosuoritus- ja opiskeluoikeustietoja sekä UniHow-järjestelmän lokitietoja (tarkemmin määritelty tietosuojailmoituksessa) voidaan yhdistää tässä kyselyssä antamiisi vastauksiin. Yksittäisten opiskelijoiden tietoja ei tulla missään vaiheessa raportoimaan. Aineistot käsitellään, analysoidaan ja säilytetään luottamuksellisesti. Palautteet raportoidaan hyviä tieteellisiä käytäntöjä noudattaen.</p><p>Tutkimusluvan antaminen on täysin vapaaehtoista, eikä sen antaminen vaikuta saamaasi vastapalautteeseen. Tutkimusluvan voi myös peruuttaa.</p>",
        "HUP": "<p>Pyydämme lupaa käyttää vastauksiasi tohtorikoulutuksen tutkimuksessa. Tutkimuskäytön yhteydessä opintotietojärjestelmän opintosuoritus- ja opiskeluoikeustietoja (tarkemmin määritelty tietosuojailmoituksessa) voidaan yhdistää tässä kyselyssä antamiisi vastauksiin. Yksittäisten vastaajien tietoja ei raportoida missään vaiheessa. Aineistot käsitellään, analysoidaan ja säilytetään luottamuksellisesti. Palautteet raportoidaan hyviä tieteellisiä käytäntöjä noudattaen.</p><p>Tutkimusluvan antaminen on täysin vapaaehtoista, eikä sen antaminen vaikuta saamaasi palautteeseen. Tutkimusluvan voi myös peruuttaa.</p>",
        "HUT": "<p>Pyydämme lupaa käyttää vastauksiasi tutkimuksessa. Yksittäisten vastaajien tietoja ei raportoida missään vaiheessa. Aineistot käsitellään, analysoidaan ja säilytetään luottamuksellisesti. Palautteet raportoidaan hyviä tieteellisiä käytäntöjä noudattaen.</p><p>Tutkimusluvan antaminen on täysin vapaaehtoista, eikä sen antaminen vaikuta saamaasi palautteeseen. Tutkimusluvan voi myös peruuttaa.</p>"
      },
      "furtherInformation": "Lisätietoja tutkimuskäytöstä ja tutkimusluvan peruuttamisesta:",
      "privacyNotice": "Tutkimuskäytön tietosuojailmoitus:"
    }
  },
  "surveysLandingPage": {
    "title": "Kyselyt",
    "hulSurvey": "HowULearn-kysely",
    "hulSurveyDescription": "HowULearn-kyselyn väittämät liittyvät muun muassa opiskelijan sitoutuneisuuteen, hyvinvointiin, opiskelukokemuksiin ja mielipiteisiin oppimisympäristöstä. HowULearn-kyselyssä pyritään selvittämään opintokokonaisuuteen liittyviä opiskelijan kokemuksia eikä keskitytä tiettyihin kursseihin tai opintosarjoihin.",
    "husSurvey": "HowUStudy-kysely",
    "husSurveyDescription": "HowUStudy-kyselyitä käytetään palautteen keräämiseen yksittäisestä kurssista tai opintokokonaisuudesta perinteisen kurssipalautelomakkeen sijaan. HowUStudy-kyselyt ovat luonteeltaan pelkistetympiä kuin HowULearn-kyselyt.",
    "hupSurvey": "PhD-kysely",
    "hupSurveyDescription": "PhD-kyselyn väittämät liittyvät väitöskirjatutkijan kokemuksiin väitöskirjatutkimusprosessista. Kyselyllä selvitetään esimerkiksi väitöskirjatutkijoiden kokemuksia motivaatiostaan, jatko-opintoihin liittyvästä hyvinvoinnistaan sekä ohjaajan ja tiedeyhteisön tuesta.",
    "hutSurvey": "HowUTeach-kysely",
    "hutSurveyDescription": "HowUTeach-kysely on tarkoitettu korkeakouluopettajien itsereflektion välineeksi. HowUTeach-kyselyn väittämät liittyvät esimerkiksi kokemuksiin omasta opetuksesta ja työyhteisöstä sekä hyvinvointiin.",
    "buttons": {
      "start": "Käynnistä kysely",
      "browse": "Selaa kyselyitä"
    }
  },
  "selectSchemaDialog": {
    "title": "Käynnistä uusi ${ schemaType }",
    "selectSchema": "Valitse kyselypohja"
  },
  "selectSchemaTypeDialog": {
    "title": "Valitse kyselytyyppi",
    "label": "Valitse kyselytyyppi, jolle kyselypohja luodaan"
  },
  "selectSurveyPartTypeDialog": {
    "surveyPartLabel": "Valitse kyselytyyppi, jolle osakysely luodaan",
    "extraPartLabel": "Valitse kyselytyyppi, jolle lisäkysymys luodaan"
  },
  "adminTools": {
    "title": "Pääkäyttäjän työkalut",
    "permissions": "Käyttöoikeudet",
    "activityLog": "Aktiviteettiloki"
  },
  "accessibilityStatement": {
    "mainTitle": "Saavutettavuusseloste",
    "generalInfo": "Tämä saavutettavuusseloste koskee verkkopalvelua UniHow ja on päivitetty 18.3.2026. Verkkopalvelua koskee laki digitaalisten palvelujen tarjoamisesta, jossa edellytetään, että julkisten verkkopalvelujen on oltava saavutettavia. Verkkopalvelun saavutettavuuden on arvioinut ulkopuolinen asiantuntijaorganisaatio.",
    "accessibilityStatementHeading": "Digipalvelun saavutettavuuden tila",
    "accessibilityStatementContent": "Tämä verkkopalvelu täyttää saavutettavuusvaatimukset osittain.",
    "nonAccessibleContentHeading": "Ei-saavutettava sisältö",
    "nonAccessibilityGeneralInfo": "Verkkopalvelu ei ole vielä kaikilta osin vaatimusten mukainen. Seuraava sisältö ja/tai toiminnot eivät ole vielä vaatimusten mukaisia:",
    "listOfAccessibilityErrors": [
      {
        "heading": "Yleiset, koskevat koko verkkopalvelua",
        "descriptionList": [
          "Verkkopalvelu ei ilmoita käyttäjälle automaattisen uloskirjautumisen aikarajasta. (WCAG 2.2.1)."
        ]
      },
      {
        "heading": "Etusivu",
        "descriptionList": [
          "Ota yhteyttä -modaalin sulkemispainikkeelta puuttuu tekstivastine (WCAG 4.1.2).",
          "Ota yhteyttä -viestikentältä puuttuu saavutettava nimilappu (WCAG 1.1.1, 3.3.2, 4.1.2).",
          "Ota yhteyttä -komponentin kiitosviestissä ei ole riittävästi kontrastia (WCAG 1.4.3)."
        ]
      },
      {
        "heading": "Palaute",
        "descriptionList": [
          "Ruudunlukija ei lue ”Ryhmän keskiarvo” -tekstiä, koska HTML:ssä on virhe. (WCAG 1.1.1, 1.3.1).",
          "Ruudunlukija ei lue graafien prosenttimääriä. (WCAG 1.1.1)."
        ]
      }
    ],
    "contactInformationHeading": "Saavutettavuuspalaute ja yhteystiedot",
    "contactInformationContent": "Otamme mielellämme vastaan ehdotuksia, huomioita, kysymyksiä ja parannusehdotuksia tähän verkkopalveluun ja sen saavutettavuuteen liittyen sähköpostitse osoitteeseen",
    "governingAgencyHeading": "Valvontaviranomainen",
    "governingAgencyContent": "Jos huomaat verkkopalvelussa saavutettavuusongelmia, anna ensin palautetta meille eli sivuston ylläpitäjälle. Vastauksessa voi mennä 14 päivää. Jos et ole tyytyväinen saamaasi vastaukseen tai et saa vastausta lainkaan kahden viikon aikana, voit tehdä ilmoituksen valvontaviranomaiselle.",
    "governingAgencyContactHeading": "Valvontaviranomaisen yhteystiedot",
    "governingAgencyName": "Liikenne- ja viestintävirasto Traficom\nSaavutettavuusvalvonta",
    "governingAgencyUrl": "www.saavutettavuusvaatimukset.fi/fi",
    "governingAgencyEmail": "saavutettavuus@traficom.fi",
    "governingAgencyPhoneDescription": "puhelinnumero (vaihde)",
    "governingAgencyPhoneNumber": "029 534 5000"
  },
  "errorSummary": {
    "heading": "Korjaa tai täydennä seuraavia tietoja"
  }
}
